import React from "react";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Typography,
} from "@mui/material";

interface AgreementCheckProps {
  register: any;
  errors: any;
}

const AgreementCheck: React.FC<AgreementCheckProps> = ({
  register,
  errors,
}) => {
  return (
    <FormGroup>
      <FormControlLabel
        {...register("agreedLegalTerms")}
        control={<Checkbox sx={{ marginTop: "-20px" }} />}
        label={
          <Typography fontSize={13}>
            Li e concordo com os &nbsp;
            <a
              style={{ color: "#820AD1", fontSize: 13 }}
              href="https://portal.delend.com.br/static/media/termos-condicoes-uso.pdf"
              target={"_blank"}
              rel="noreferrer"
            >
              Termos de Uso
            </a>
            &nbsp; e a &nbsp;
            <a
              style={{ color: "#820AD1", fontSize: 13 }}
              href="https://portal.delend.com.br/static/media/politica-privacidade.pdf"
              target={"_blank"}
              rel="noreferrer"
            >
              Política de privacidade
            </a>
          </Typography>
        }
      />
      {errors.agreedLegalTerms && (
        <FormHelperText error>{errors.agreedLegalTerms.message}</FormHelperText>
      )}
    </FormGroup>
  );
};

export default AgreementCheck;
